import { InjectionToken, Provider } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { Payment } from '@payment/const';
import { StateUtils } from '@spartacus/core';
import { PAYMENT_BIND_PAYMENT, PAYMENT_DELETE_PAYMENT, PAYMENT_LIST, PaymentState } from '../payment-state';

export type PaymentReducers = PaymentState;

export function getReducers(): ActionReducerMap<PaymentReducers> {
  return {
    paymentList: StateUtils.loaderReducer<Payment[]>(PAYMENT_LIST),
    deletePayment: StateUtils.loaderReducer<void>(PAYMENT_DELETE_PAYMENT),
    bindPayment: StateUtils.loaderReducer<string | null>(PAYMENT_BIND_PAYMENT),
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<PaymentReducers>> = new InjectionToken<
  ActionReducerMap<PaymentReducers>
>('PaymentReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
